import { render, staticRenderFns } from "./videos_widget.vue?vue&type=template&id=7b614056&"
import script from "./videos_widget.vue?vue&type=script&lang=js&"
export * from "./videos_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b614056')) {
      api.createRecord('7b614056', component.options)
    } else {
      api.reload('7b614056', component.options)
    }
    module.hot.accept("./videos_widget.vue?vue&type=template&id=7b614056&", function () {
      api.rerender('7b614056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcBlockVideos/assets/components/videos_widget.vue"
export default component.exports